import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomBadge, {atomBadgeDesigns, atomBadgeSizes, atomBadgeTypes} from '@s-ui/react-atom-badge'
import {ATOM_ICON_SIZES, atomIconSizes} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import ListBasic, {listItemsColors, listTitleSizes, listTypes} from '@adv-mt/mt-list-basic'
import CheckIcon from '@adv-mt/mt-svg-icons/lib/Check'
import InfoIcon from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'
import IconStarFull from '@adv-mt/mt-svg-icons/lib/StarFull'

export const ReservationInfo = ({adInfo, handleLinkInfoClick}) => {
  const {i18n} = useContext(Context)

  const commonListBasicProps = {
    isSingleColumn: true,
    itemsColor: listItemsColors.CURRENT_COLOR,
    titleSize: listTitleSizes.xxs,
    type: listTypes.ICON
  }

  const items = [
    {
      icon: () => <CheckIcon size={ATOM_ICON_SIZES.medium} />,
      value: 'Reservar es una señal clara de interés. \nEl concesionario te dará máxima prioridad.'
    },
    {
      icon: () => <CheckIcon size={ATOM_ICON_SIZES.medium} />,
      value: 'Recuerda, siempre te devolveremos tus \n99€ pase lo que pase.'
    }
  ]

  const isImageAvailable = Boolean(adInfo?.imageUrl)

  return (
    <div className="mt-DrawerReservationInitialization-info">
      <span className="mt-DrawerReservationInitialization-adTitle">{adInfo?.title}</span>
      {isImageAvailable && (
        <div className={`mt-DrawerReservationInitialization-imageWrapper`}>
          {adInfo?.price && (
            <AtomBadge
              className="mt-DrawerReservationInitialization-badge--isTop"
              size={atomBadgeSizes.LARGE}
              type={atomBadgeTypes.NEUTRAL}
              label={i18n.c(adInfo.price)}
            />
          )}
          {adInfo?.instalment && (
            <AtomBadge
              className="mt-DrawerReservationInitialization-badge"
              size={atomBadgeSizes.LARGE}
              type={atomBadgeTypes.NEUTRAL}
              label={i18n.c(adInfo.instalment) + '/mes'}
            />
          )}
          <AtomImage
            src={adInfo?.imageUrl || ''}
            className={`mt-DrawerReservationInitialization-image`}
            role="presentation"
          />
        </div>
      )}
      {Boolean(adInfo?.dealerRating) && (
        <div className="mt-DrawerReservationInitialization-dealerRatingBadge">
          <AtomBadge
            design={atomBadgeDesigns.SOFT}
            icon={
              <div className="mt-DrawerReservationInitialization-iconRatingStar">
                <IconStarFull
                  color="currentColor"
                  size={atomIconSizes.extraSmall}
                  title={`${i18n.t('COMMON_PROFESSIONAL')} ${adInfo?.dealerRating?.average}`}
                />
              </div>
            }
            iconRight
            label={`${i18n.t('COMMON_PROFESSIONAL')} ${adInfo?.dealerRating?.average}`}
            size={atomBadgeSizes.MEDIUM}
            type={atomBadgeTypes.INFO}
          />
        </div>
      )}

      <span className="mt-DrawerReservationInitialization-dealerName">{adInfo.dealerName.toUpperCase()}</span>
      <div className="mt-DrawerReservationInitialization-linkInfo">
        <InfoIcon color="currentColor" size={atomIconSizes.small} />
        <span className="mt-DrawerReservationInitialization-linkInfoText" onClick={handleLinkInfoClick}>
          ¿Qué pasa cuando reservo?
        </span>
      </div>
      <ListBasic {...commonListBasicProps} items={items} />
    </div>
  )
}

ReservationInfo.displayName = 'ReservationInfo'
ReservationInfo.propTypes = {
  adInfo: PropTypes.object,
  handleLinkInfoClick: PropTypes.func
}
